<template lang="pug">
  menu-bar-item(:label=`$t('tool')`)
    menu-item(:label=`$t('pan')`, type="radio", v-model="module.type", value="PAN")
    menu-item(:label=`$t('rectangle_selection_(press_shift_key)')`, type="radio", v-model="module.type", value="RECT_SELECT")
    menu-item(:label=`$t('linear_selection_(press_meta_key)')`, type="radio", v-model="module.type", value="LINE_SELECT")
</template>


<script lang="ts">
import Vue from 'vue'
export default Vue.extend({
  props: {
    module: { required: true },
  },
})
</script>

<i18n>
en:
  tool: Tool
  pan: Pan
  rectangle_selection_(press_shift_key): Rectangle Selection (Press Shift Key)
  linear_selection_(press_meta_key): Linear Selection (Press Meta Key)
ja:
  tool: ツール
  pan: 移動
  rectangle_selection_(press_shift_key): 矩形選択 (shiftキー)
  linear_selection_(press_meta_key): 線形選択 (metaキー)

</i18n>